import { z } from "zod";
export const galleryCaption = z
  .object({
    text: z.string().min(1).max(4000),
    position: z.enum(["above", "below", "left", "right"]).default("below"),
    fontSize: z.number().min(8).max(96).default(16),
    bold: z.boolean().default(false),
    align: z.enum(["start", "middle", "end"]).default("start"),
    color: z
      .enum(["black", "red", "orange", "blue", "green", "grey"])
      .default("black"),
    gap: z.number().min(0).max(200).default(12),
    width: z.number().positive().max(2000).optional(),
  })
  .strict();

// Conservative line estimate reserves space for captions without decoding images
// or retaining all source bytes. Actual rich text remains editable in the renderer.
export function captionHeight(
  c: z.infer<typeof galleryCaption>,
  width: number,
) {
  const chars = Math.max(1, Math.floor(width / (c.fontSize * 0.65)));
  return (
    c.text
      .split("\n")
      .reduce((n, line) => n + Math.max(1, Math.ceil(line.length / chars)), 0) *
    c.fontSize *
    1.5
  );
}
